<app-confirm-delete-alert #confirmaction></app-confirm-delete-alert>
<ion-list style="position: relative;" >
  <ion-grid  style="position: sticky;top: 0;z-index: 100;">
    <ion-row>
      <ion-col size="12" sizeSm="12" > 
          <ion-searchbar  debounce="1" style="--border-radius: 50px;" [placeholder]="manager.Trad.Parse('STR_PLACEHOLDER_SEARCH')"  [(ngModel)]="searchText" class="custom" ></ion-searchbar>
      </ion-col>     
    </ion-row>
  </ion-grid>
  <ion-item (click)="Data.navigateTo()" *ngFor="let Data of Datas">
    <ion-label class="">      
      <ion-text color="secondary">
        <h2 class="ion-text-wrap">{{Data.DisplayName}}</h2>
      </ion-text>
      <ion-text color="medium" >
        <p style="font-size: 14px;" class="text-ellipsis">{{Data.Email}}</p>
      </ion-text>
      <ion-text  color="primary">
       <p>{{Data.DisplayLastLogin}}</p>
      </ion-text>      
    </ion-label>
    
    <ion-label slot="end"  class="">
      <ion-text color="secondary" >
        <p style="margin-right: 22px;">{{manager.Trad.Parse(Data.AccountType)}}</p>
      </ion-text>
    </ion-label>
  </ion-item>
</ion-list>